import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box"
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden"
};

const img = {
  display: "block",
  width: "100%",
  height: "auto"
};

let thumbs;

function Previews(props) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: acceptedFiles => {
      setFiles(
        acceptedFiles.map(file => {
          console.log(acceptedFiles)
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
          myHeaders.append(
            "Authorization",
            localStorage.getItem("livelms_auth")
          );
          // var imageArr = [data];
          var urlencoded = new URLSearchParams();
          urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
          urlencoded.append("media", acceptedFiles);

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
          };
          // console.log(imageArr);

          fetch("https://livelms.in/api/media/add", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              return result;
            })
            .catch((error) => console.log("error", error));
          var formData = new FormData();
          formData.append("media", acceptedFiles);
          formData.append("siteId", localStorage.getItem("lms_site_id"));

          fetch(`https://livelms.in/api/media/add`, {
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization":
                localStorage.getItem("livelms_auth"),
            },
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              // this.setState({ images: data.images, isLoading: false });
              // this.props.updateImages(data.images);
            })
            .catch((error) => console.log(error));
          return Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        }
        )
      );
    }
  });




  thumbs = files.map(file => (
    <div key={file.name}>
      <div>
        <img src={file.preview} style={img} className="add-image" />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <section className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
      <div {...getRootProps({ className: "dropzone" })} style={{ width: "100%", height: "300px" }}>
        <input {...getInputProps()} />
        {/* <div className="add-image-icon">
          <i class="far fa-images"></i>
        </div> */}
        <aside>{thumbs}</aside>
      </div>
    </section>
  );
}

export default Previews;
